export default {
  "badgewall_achievement_detail": {
      "en": "Achievement Detail",
      "ja": "実績の詳細",
      "ko": "업적 세부정보",
      "zh": "成就詳情",
      "zh_cn": "成就详情"
  },
  "badgewall_achievement_points": {
      "en": "Achievement points",
      "ja": "実績ポイント",
      "ko": "성취 포인트",
      "zh": "成績點數",
      "zh_cn": "成绩点数"
  },
  "badgewall_active_days": {
      "en": "Active days",
      "ja": "アクティブ日数",
      "ko": "활동적인 날",
      "zh": "活躍天數",
      "zh_cn": "活跃天数"
  },
  "badgewall_back": {
      "en": "Back",
      "ja": "戻る",
      "ko": "뒤쪽에",
      "zh": "返回",
      "zh_cn": "返回"
  },
  "badgewall_claim": {
      "en": "Claim",
      "ja": "受け取る",
      "ko": "주장하다",
      "zh": "領取",
      "zh_cn": "领取"
  },
  "badgewall_claim_error_tips": {
      "en": "Please claim the rewards from the previous stage first",
      "ja": "前の段階の報酬を先に受け取ってください",
      "ko": "이전 단계의 보상을 먼저 수령해주세요.",
      "zh": "請先領取上一階段的獎勵",
      "zh_cn": "请先领取上一阶段的奖励"
  },
  "badgewall_claimed": {
      "en": "Claimed",
      "ja": "受け取り済",
      "ko": "청구됨",
      "zh": "已領取",
      "zh_cn": "已领取"
  },
  "badgewall_claimed_by_other": {
      "en": "Claimed by other player",
      "ja": "他人に受領済み",
      "ko": "다른 플레이어가 소유권을 주장함",
      "zh": "已被他人領取",
      "zh_cn": "已被他人领取"
  },
  "badgewall_default1": {
      "en": "No achievements available",
      "ja": "成果なし",
      "ko": "사용 가능한 업적이 없습니다.",
      "zh": "沒有獲得成就",
      "zh_cn": "没有获得成就"
  },
  "badgewall_default2": {
      "en": "No achievement medal now",
      "ja": "現在アチーブメントメダルはありません",
      "ko": "이제 업적 메달이 없습니다",
      "zh": "當前沒有成就勛章",
      "zh_cn": "当前没有成就勋章"
  },
  "badgewall_default3": {
      "en": "Wallet not connected, unable to view now",
      "ja": "ウォレットが接続されていないため、現在閲覧できません",
      "ko": "월렛이 연결되지 않아 지금은 볼 수 없습니다.",
      "zh": "未鏈接錢包，當前無法查看",
      "zh_cn": "未链接钱包，当前无法查看"
  },
  "badgewall_honor": {
      "en": "HONOR",
      "ja": "栄誉",
      "ko": "명예",
      "zh": "榮譽",
      "zh_cn": "荣誉"
  },
  "badgewall_incomplete": {
      "en": "Incomplete",
      "ja": "未完成",
      "ko": "불완전한",
      "zh": "未完成",
      "zh_cn": "未完成"
  },
  "badgewall_medal": {
      "en": "Medal",
      "ja": "メダル",
      "ko": "메달",
      "zh": "勛章",
      "zh_cn": "勋章"
  },
  "badgewall_medal_number": {
      "en": "Medal Number",
      "ja": "メダルの数",
      "ko": "메달 번호",
      "zh": "勛章數量",
      "zh_cn": "勋章数量"
  },
  "badgewall_medal_rank": {
      "en": "Medal Rank",
      "ja": "メダルランク",
      "ko": "메달 순위",
      "zh": "勛章排名",
      "zh_cn": "勋章排名"
  },
  "badgewall_medals": {
      "en": "Medals",
      "ja": "メダル",
      "ko": "메달",
      "zh": "勛章",
      "zh_cn": "勋章"
  },
  "badgewall_medalwall": {
      "en": "Medal Wall",
      "ja": "メダルウォール",
      "ko": "메달 벽",
      "zh": "勛章墻",
      "zh_cn": "勋章墙"
  },
  "badgewall_no_rankingdata": {
      "en": "Ranking list is being updated...",
      "ja": "ランキングリストは更新中です...",
      "ko": "순위 목록이 업데이트 중입니다...",
      "zh": "排行榜正在更新中...",
      "zh_cn": "排行榜正在更新中..."
  },
  "badgewall_point": {
      "en": "Point",
      "ja": "ポイント",
      "ko": "가리키다",
      "zh": "分數",
      "zh_cn": "分数"
  },
  "badgewall_point_rank": {
      "en": "Point Rank",
      "ja": "ポイントランク",
      "ko": "포인트 순위",
      "zh": "分數排名",
      "zh_cn": "分数排名"
  },
  "badgewall_points": {
      "en": "Points",
      "ja": "ポイント",
      "ko": "포인트들",
      "zh": "分數",
      "zh_cn": "分数"
  },
  "badgewall_radar1": {
      "en": "Yuli's growth",
      "ja": "Yuliの成長",
      "ko": "율리의 성장",
      "zh": "Yuli養成",
      "zh_cn": "Yuli养成"
  },
  "badgewall_radar2": {
      "en": "Chip\nenhancement",
      "ja": "チップの強化",
      "ko": "칩 강화",
      "zh": "芯片培養",
      "zh_cn": "芯片培养"
  },
  "badgewall_radar3": {
      "en": "Item\nsynthesis",
      "ja": "アイテム合成",
      "ko": "아이템 합성",
      "zh": "材料合成",
      "zh_cn": "材料合成"
  },
  "badgewall_radar4": {
      "en": "COA",
      "ja": "COA",
      "ko": "COA",
      "zh": "卡牌相關",
      "zh_cn": "卡牌相关"
  },
  "badgewall_radar5": {
      "en": "Hunt&Explore",
      "ja": "宝探しと探検",
      "ko": "사냥&탐험",
      "zh": "尋寶探索",
      "zh_cn": "寻宝探索"
  },
  "badgewall_radar6": {
      "en": "Guide's\ngrowth",
      "ja": "ガイドの成長",
      "ko": "가이드의 성장",
      "zh": "主角養成",
      "zh_cn": "主角养成"
  },
  "badgewall_ranking_tips": {
      "en": "Refresh at 0 UTC+0 every day",
      "ja": "毎日 0 UTC+0 に更新します",
      "ko": "매일 0 UTC+0에 새로 고침",
      "zh": "每天0點（UTC+0）刷新",
      "zh_cn": "每天0点（UTC+0）刷新"
  },
  "badgewall_share": {
      "en": "Share",
      "ja": "共有する",
      "ko": "공유하다",
      "zh": "分享",
      "zh_cn": "分享"
  },
  "badgewall_share_tips1": {
      "en": "Congratulations! You got a new badge, go and share it with your friends!",
      "ja": "おめでとう！新しいバッジを\n取得しました。友達と共有し\nてください!",
      "ko": "축하합니다. 새 배지를 받으셨으니 가서 친구들과 공유해 보세요!",
      "zh": "恭喜你！你獲得了一個新勛章，快去和小夥伴們分享吧！",
      "zh_cn": "恭喜你！你获得了一个新勋章，快去和小伙伴们分享吧！"
  },
  "badgewall_share_tips2": {
      "en": "So amazing! You've earned so many medals! Go and show off to your friends!",
      "ja": "本当に素晴らしい！たくさんのメダルを獲得しました！友達に自慢しに行ってください！",
      "ko": "정말 놀랍습니다! 메달을 너무 많이 획득하셨습니다! 가서 친구들에게 자랑해보세요!",
      "zh": "太棒了！你已經擁有這麽多勛章了！快去和小夥伴們炫耀吧！",
      "zh_cn": "太棒了！你已经拥有这么多勋章了！快去和小伙伴们炫耀吧！"
  },
  "badgewall_share_tips3": {
      "en": "Marvelous! You have collected all badges! Badge Master is none other than you! Go and share the glory!",
      "ja": "素晴らしい！すべてのバッジを集めました!バッジマスターは他ならぬあなたです！行って栄光を分かち合いましょう！",
      "ko": "대단하네요! 모든 배지를 수집하셨습니다! 배지 마스터는 바로 당신입니다! 가서 영광을 공유하세요!",
      "zh": "不可思議！你已經集齊全部勛章了！勛章大師非你莫屬，快去分享這份榮耀吧！",
      "zh_cn": "不可思议！你已经集齐全部勋章了！勋章大师非你莫属，快去分享这份荣耀吧！"
  },
  "badgewall_sharepage_footer1": {
      "en": "IRL Metaverse Game",
      "ja": "IRL メタバース ゲーム",
      "ko": "IRL 메타버스 게임",
      "zh": "現實虛擬宇宙遊戲",
      "zh_cn": "现实虚拟宇宙游戏"
  },
  "badgewall_sharepage_footer2": {
      "en": "BNB Chain Star Project",
      "ja": "BNBチェーンスタープロジェクト",
      "ko": "BNB 체인 스타 프로젝트",
      "zh": "BNB鏈明星項目",
      "zh_cn": "BNB链明星项目"
  },
  "badgewall_sharepage_label0": {
      "en": "Junior Collector!",
      "ja": "いちじコレクター！",
      "ko": "주니어 콜렉터!",
      "zh": "初級收藏家",
      "zh_cn": "初级收藏家！"
  },
  "badgewall_sharepage_label1": {
      "en": "Excellent Collector!",
      "ja": "優秀なコレクター！",
      "ko": "훌륭한 수집가!",
      "zh": "優秀收藏家！",
      "zh_cn": "优秀收藏家！"
  },
  "badgewall_sharepage_label2": {
      "en": "Avid Collector!",
      "ja": "マニアコレクター！",
      "ko": "열렬한 수집가!",
      "zh": "狂熱收藏家",
      "zh_cn": "狂热收藏家！"
  },
  "badgewall_sharepage_label3": {
      "en": "Senior Collector!",
      "ja": "ベテランコレクター！",
      "ko": "시니어 콜렉터!",
      "zh": "資深收藏家",
      "zh_cn": "资深收藏家！"
  },
  "badgewall_sharepage_touser": {
      "en": "The master of achievement is none other than me.",
      "ja": "実績の達人は私ではない",
      "ko": "성취의 주인은 다름 아닌 나이다.",
      "zh": "成就大師非我莫屬",
      "zh_cn": "成就大师非我莫属"
  },
  "badgewall_sharepage_touser1": {
      "en": "This is the <%>th medal I have won, the master of achievement is none other than me",
      "ja": "これは私が獲得した<%>個目のメダルです、実績の達人は私ではない！",
      "ko": "이것은 내가 <%>번째로 획득한 메달입니다. 성취의 주인은 바로 나입니다.",
      "zh": "這是我獲得的第<%>個成就勛章，成就大師非我莫屬",
      "zh_cn": "这是我获得的第<%>个成就勋章，成就大师非我莫属"
  },
  "badgewall_statistics": {
      "en": "Statistics",
      "ja": "統計",
      "ko": "통계",
      "zh": "統計",
      "zh_cn": "统计"
  },
  "badgewall_statistics_above": {
      "en": "Above<%>of other players",
      "ja": "他のプレイヤーの<%>以上",
      "ko": "<%>다른 플레이어보다 높음",
      "zh": "超過<%>的玩家",
      "zh_cn": "超过<%>的玩家"
  },
  "badgewall_statistics_label1": {
      "en": "Achievement trend",
      "ja": "実績の傾向",
      "ko": "성취동향",
      "zh": "成就趨勢",
      "zh_cn": "成就趋势"
  },
  "badgewall_statistics_label2": {
      "en": "Ranking",
      "ja": "ランキング",
      "ko": "순위",
      "zh": "排名",
      "zh_cn": "排名"
  },
  "badgewall_statistics_noinrank": {
      "en": "Sorry, you are not on the rank",
      "ja": "残念ながら、ランク外です",
      "ko": "죄송합니다. 당신은 순위에 없습니다",
      "zh": "很遺憾，你沒有上榜",
      "zh_cn": "很遗憾，你没有上榜"
  },
  "badgewall_tab1": {
      "en": "Summary",
      "ja": "概要",
      "ko": "요약",
      "zh": "總覽",
      "zh_cn": "总览"
  },
  "badgewall_tab2": {
      "en": "Milestone",
      "ja": "マイルストーン",
      "ko": "중요한 단계",
      "zh": "裏程碑",
      "zh_cn": "里程碑"
  },
  "badgewall_title": {
      "en": "Achievements",
      "ja": "実績",
      "ko": "업적",
      "zh": "成就",
      "zh_cn": "成就"
  },
  "badgewall_total_number": {
      "en": "Total Number",
      "ja": "総数",
      "ko": "총 수",
      "zh": "總數",
      "zh_cn": "总数"
  },
  "badgewall_unranked": {
      "en": "Unranked",
      "ja": "ランキング外",
      "ko": "순위 없음",
      "zh": "未上榜",
      "zh_cn": "未上榜"
  },
  "katharsis_claim_button": {
      "en": "Claim",
      "ja": "受け取る",
      "ko": "주장하다",
      "zh": "領取",
      "zh_cn": "领取"
  },
  "katharsis_daily": {
      "en": "Daily",
      "ja": "毎日",
      "ko": "일일",
      "zh": "每日",
      "zh_cn": "每日"
  },
  "katharsis_day": {
      "en": "day(s)",
      "ja": "日",
      "ko": "날)",
      "zh": "天",
      "zh_cn": "天"
  },
  "katharsis_deadline": {
      "en": "The Remaining Period",
      "ja": "残りの期間",
      "ko": "남은 기간",
      "zh": "剩余期限",
      "zh_cn": "剩余期限"
  },
  "katharsis_error_msg1": {
      "en": "The event has ended and the rewards cannot be claimed",
      "ja": "イベントが終了したため報酬を受け取ることができません",
      "ko": "이벤트가 종료되어 보상을 받을 수 없습니다.",
      "zh": "活動已結束，無法領取獎勵。",
      "zh_cn": "活动已结束，无法领取奖励。"
  },
  "katharsis_error_msg2": {
      "en": "Claim failed, Please try again.",
      "ja": "受け取りに失敗しました。もう一度お試しください。",
      "ko": "소유권을 주장하지 못했습니다. 다시 시도해 주세요.",
      "zh": "領取失敗，請重試。",
      "zh_cn": "领取失败，请重试。"
  },
  "katharsis_error_msg3": {
      "en": "The reward has been claimed",
      "ja": "報酬はすでに受領されている。",
      "ko": "보상이 청구되었습니다",
      "zh": "獎勵已被領取。",
      "zh_cn": "奖励已被领取。"
  },
  "katharsis_exp_limit": {
      "en": "Weekly Limit",
      "ja": "週の上限",
      "ko": "주간 한도",
      "zh": "每周上限",
      "zh_cn": "每周上限"
  },
  "katharsis_free": {
      "en": "Free",
      "ja": "無料",
      "ko": "무료",
      "zh": "免費",
      "zh_cn": "免费"
  },
  "katharsis_full_level": {
      "en": "Full level",
      "ja": "レベル上限",
      "ko": "전체 레벨",
      "zh": "滿級",
      "zh_cn": "满级"
  },
  "katharsis_got_button": {
      "en": "I got it",
      "ja": "わかった",
      "ko": "알겠어요",
      "zh": "我知道了",
      "zh_cn": "我知道了"
  },
  "katharsis_hour": {
      "en": "hour(s)",
      "ja": "時間",
      "ko": "시간)",
      "zh": "小時",
      "zh_cn": "小时"
  },
  "katharsis_missions": {
      "en": "Missions",
      "ja": "ミッション",
      "ko": "임무",
      "zh": "任務",
      "zh_cn": "任务"
  },
  "katharsis_page": {
      "en": "Katharsis",
      "ja": "Katharsis",
      "ko": "카타르시스",
      "zh": "Katharsis",
      "zh_cn": "Katharsis"
  },
  "katharsis_pro": {
      "en": "Pro",
      "ja": "プロ",
      "ko": "찬성",
      "zh": "高級",
      "zh_cn": "高级"
  },
  "katharsis_receive_full": {
      "en": "Receive in full",
      "ja": "全額受け取る",
      "ko": "전액 수령",
      "zh": "一鍵領取",
      "zh_cn": "一键领取"
  },
  "katharsis_reward": {
      "en": "Reward",
      "ja": "報酬",
      "ko": "보상",
      "zh": "獎勵",
      "zh_cn": "奖励"
  },
  "katharsis_rule_content1": {
      "en": "Katharsis Missions is unlocked by default at the start of each period.",
      "ja": "カタルシス ミッションは、デフォルトで各期間の開始時にロック解除されます。",
      "ko": "카타르시스 미션은 기본적으로 각 기간이 시작될 때 잠금 해제됩니다.",
      "zh": "卡塔西斯任務在每個活動周期開始時默認解鎖。",
      "zh_cn": "卡塔西斯任务在每个活动周期开始时默认解锁。"
  },
  "katharsis_rule_content2": {
      "en": "Daily missions are updated each day at 4:00 AM, and weekly missions are updated each Monday at 4:00 AM (UTC+8).",
      "ja": "デイリーミッションは毎日午前 4:00 に更新され、ウィークリーミッションは毎週月曜日午前 4:00 (UTC+8) に更新されます。",
      "ko": "일일 미션은 매일 오전 4시에 업데이트되며, 주간 미션은 매주 월요일 오전 4시(UTC+8)에 업데이트됩니다.",
      "zh": "每日任務於每天淩晨 4:00 更新，每周任務於每周一淩晨 4:00 (UTC+8) 更新。",
      "zh_cn": "每日任务于每天凌晨 4:00 更新，每周任务于每周一凌晨 4:00 (UTC+8) 更新。"
  },
  "katharsis_rule_content3": {
      "en": "Complete Katharsis Missions to gain Katharsis EXP (KEP).",
      "ja": "カタルシス ミッションを完了してカタルシス経験値 (KEP) を獲得します。",
      "ko": "카타르시스 임무를 완료하여 카타르시스 경험치(KEP)를 획득하세요.",
      "zh": "完成Katharsis任務以獲得卡塔西斯經驗值(KEP)。",
      "zh_cn": "完成Katharsis任务以获得 卡塔西斯经验值(KEP)。"
  },
  "katharsis_rule_content4": {
      "en": "KEP increases your Katharsis Level, which brings rich rewards.",
      "ja": "KEP によりカタルシス レベルが向上し、豪華な報酬が得られます。",
      "ko": "KEP는 카타르시스 레벨을 높여 풍부한 보상을 제공합니다.",
      "zh": "KEP可以提高你的卡塔西斯等級，從而帶來豐厚的獎勵。",
      "zh_cn": "KEP可以提高你的卡塔西斯等级，从而带来丰厚的奖励。"
  },
  "katharsis_rule_content5": {
      "en": "For this KEP Period, Katharsis Missions will stop providing KEP after you reach the maximum Katharsis Level.",
      "ja": "KEP期間中に最大カタルシス レベルに達するとカタルシスミッションはKEP の提供を停止します。",
      "ko": "이 KEP 기간 동안 카타르시스 미션은 최대 카타르시스 레벨에 도달한 후 KEP 제공을 중단합니다.",
      "zh": "在此論周期中，當您達到最高卡塔西斯等級後，卡塔西斯任務將停止提供 KEP。",
      "zh_cn": "在此论周期中，当您达到最高卡塔西斯等级后，卡塔西斯任务将停止提供 KEP。"
  },
  "katharsis_rule_kep_limit": {
      "en": "KEP Limit",
      "ja": "KEP上限",
      "ko": "KEP 한도",
      "zh": "KEP上限",
      "zh_cn": "KEP上限"
  },
  "katharsis_rule_level": {
      "en": "Katharsis Level",
      "ja": "カタルシスレベル",
      "ko": "카타르시스 레벨",
      "zh": "卡塔西斯等級",
      "zh_cn": "卡塔西斯等级"
  },
  "katharsis_rule_missions": {
      "en": "Katharsis Missions",
      "ja": "カタルシスミッション",
      "ko": "카타르시스 임무",
      "zh": "卡塔西斯任務",
      "zh_cn": "Katharsis 任务"
  },
  "katharsis_rules": {
      "en": "Rules",
      "ja": "ルール",
      "ko": "규칙",
      "zh": "規則",
      "zh_cn": "规则"
  },
  "katharsis_title": {
      "en": "Katharsis Rewards",
      "ja": "カタルシスリワード",
      "ko": "카타르시스 보상",
      "zh": "Katharsis 獎勵",
      "zh_cn": "Katharsis 奖励"
  },
  "katharsis_toast_msg1": {
      "en": "Network error, please try again later.",
      "ja": "ネットワークエラー。後でもう一度試してください。",
      "ko": "네트워크 오류가 발생했습니다. 나중에 다시 시도해 주세요.",
      "zh": "網絡錯誤，請重新嘗試。",
      "zh_cn": "网络错误，请重新尝试。"
  },
  "katharsis_toast_msg2": {
      "en": "Network timeout, attempting to reconnect, try times:",
      "ja": "ネットワークタイムアウト、再接続試行、試行回数:",
      "ko": "네트워크 시간 초과, 다시 연결 시도, 시도 시간:",
      "zh": "網絡超時，嘗試重新連接，嘗試次數：",
      "zh_cn": "网络超时，尝试重新连接，尝试次数："
  },
  "katharsis_upgrade_get_worth": {
      "en": "get a reward worth",
      "ja": "の価値のある報酬を獲得できます!",
      "ko": "가치 있는 보상을 받아라",
      "zh": "領取價值 的獎勵",
      "zh_cn": "领取价值 的奖励"
  },
  "katharsis_upgrade_more": {
      "en": "more than",
      "ja": "以上",
      "ko": "이상",
      "zh": "超過",
      "zh_cn": "超过"
  },
  "katharsis_upgrade_spend": {
      "en": "Spend",
      "ja": "を使って",
      "ko": "경비",
      "zh": "花費",
      "zh_cn": "花费"
  },
  "katharsis_upgrade_toup_and": {
      "en": "to upgrade and",
      "ja": "アップグレードすると、",
      "ko": "업그레이드하고",
      "zh": "升級",
      "zh_cn": "升级"
  },
  "katharsis_weekly": {
      "en": "Weekly",
      "ja": "毎週",
      "ko": "주간",
      "zh": "每周",
      "zh_cn": "每周"
  },
  "kudasai_christmas_content1": {
      "en": "Dear Players,\n\nWe greatly appreciate your participation in the Christmas Treasure Hunt. It's time to use the \"Christmas Stocking Ticket\" you've earned and spin the wheel! Please be aware that each reward may have distinct criteria for claiming. We encourage you to review the specific details on our Discord channel to fully understand the process.\n\nRemember, if you fail to claim your prize within the designated timeframe, it will unfortunately be forfeited. Should you have any further questions or require assistance, feel free to reach out to us on Discord. We're here to help!",
      "ja": "お客さま，\n\n「Christmas Treasure Hunt」へのご参加誠にありがとうございました。 獲得した「Christmas Stocking Ticket」を使ってホイールを回しましょう！各特典には受け取りの基準が異なる場合があることに注意してください。プロセスを完全に理解するために、Discord チャンネルで具体的な詳細を確認することをお勧めします。\n\n指定された期限内に賞品を受け取らなかった場合、残念ながら賞品は没収されることにご注意ください。さらにご質問がある場合、またはサポートが必要な場合は、Discord でお気軽にお問い合わせください。私たちがお手伝いします!",
      "ko": "친애하는 플레이어 여러분,\n\nTokyo Treasure Hunt 724에 참여해 주셔서 진심으로 감사드립니다. 이제 획득한 \"Web X 티켓\"을 사용하여 휠을 돌려보세요! 각 보상마다 수령 기준이 다를 수 있으니 주의하시기 바랍니다. 프로세스를 완전히 이해하려면 Discord 채널에 대한 구체적인 세부 정보를 확인하세요.\n\n지정된 기간 내에 상품을 청구하지 않으면 아쉽게도 상품이 박탈된다는 점을 기억하세요. 추가 질문이 있거나 도움이 필요한 경우 언제든지 Discord에 문의해 주세요. 저희가 도와드리겠습니다!",
      "zh": "親愛的玩家，\n\n我們非常感謝您參與聖誕節尋寶活動。是時候使用您之前獲得的「Christmas Stocking Ticket」來轉轉盤了！請註意，每個獎勵可能有不同的領取標準。我們推薦您查看我們的 Discord 頻道上的具體細節，以充分了解該流程。\n\n請記住，如果您未能在指定時間內領取獎品，獎品將被沒收。如果您有任何其他問題或需要幫助，請隨時通過 Discord 與我們聯系。我們隨時為您提供幫助！",
      "zh_cn": "亲爱的玩家，\n\n我们非常感谢您参与圣诞节寻宝活动。是时候使用您之前获得的“Christmas Stocking Ticket”来转转盘了！请注意，每个奖励可能有不同的领取标准。我们推荐您查看我们的 Discord 频道上的具体细节，以充分了解该流程。\n\n请记住，如果您未能在指定时间内领取奖品，奖品将被没收。如果您有任何其他问题或需要帮助，请随时通过 Discord 与我们联系。我们随时为您提供帮助！"
  },
  "kudasai_christmas_content2": {
      "en": "Remember, if you fail to claim your prize within the designated timeframe, it will unfortunately be forfeited. Should you have any further questions or require assistance, feel free to reach out to us on Discord. We're here to help!",
      "ja": "指定された期限内に賞品を受け取らなかった場合、残念ながら賞品は没収されることにご注意ください。さらにご質問がある場合、またはサポートが必要な場合は、Discord でお気軽にお問い合わせください。私たちがお手伝いします!",
      "ko": "지정된 기간 내에 상품을 청구하지 않으면 아쉽게도 상품이 박탈된다는 점을 기억하세요. 추가 질문이 있거나 도움이 필요한 경우 언제든지 Discord에 문의해 주세요. 저희가 도와드리겠습니다!",
      "zh": "請記住，如果您未能在指定時間內領取獎品，獎品將被沒收。如果您有任何其他問題或需要幫助，請隨時通過 Discord 與我們聯系。我們隨時為您提供幫助！",
      "zh_cn": "请记住，如果您未能在指定时间内领取奖品，奖品将被没收。如果您有任何其他问题或需要帮助，请随时通过 Discord 与我们联系。我们随时为您提供帮助！"
  },
  "kudasai_christmas_label": {
      "en": "Dear Players,",
      "ja": "お客さま，",
      "ko": "친애하는 플레이어 여러분,",
      "zh": "親愛的玩家，",
      "zh_cn": "亲爱的玩家，"
  },
  "kudasai_christmas_rules": {
      "en": "Rules",
      "ja": "ルール",
      "ko": "규칙",
      "zh": "規則",
      "zh_cn": "规则"
  },
  "kudasai_christmas_title": {
      "en": "Deadline",
      "ja": "期限",
      "ko": "마감 시간",
      "zh": "期限",
      "zh_cn": "期限"
  },
  "og_about": {
      "en": "Your current identity is not an OG player, so you cannot claim rewards.",
      "ja": "あなたは現在OG プレイヤーではないため、報酬を受け取ることはできません。",
      "ko": "현재 신분은 OG 플레이어가 아니므로 보상을 받을 수 없습니다.",
      "zh": "您當前的身份不是OG玩家，因此您無法領取獎勵。",
      "zh_cn": "您当前的身份不是OG玩家，因此您无法领取奖励。"
  },
  "og_about2": {
      "en": "Notice: Don't forget to log in every day to claim rewards.If your OG status changes during this period, you will not be able to claim the rewards",
      "ja": "注意: 報酬を受け取るために毎日忘れずにログインしてください。この期間中に OG ステータスが変化すると、報酬を受け取ることができなくなります",
      "ko": "주의 사항: 보상을 받으려면 매일 로그인하는 것을 잊지 마세요. 이 기간 동안 OG 상태가 변경되면 보상을 받을 수 없습니다.",
      "zh": "註意：不要忘記每天登錄領取獎勵。如果在此期間您的OG狀態發生變化，您將無法領取獎勵",
      "zh_cn": "注意：不要忘记每天登录领取奖励。如果在此期间您的OG状态发生变化，您将无法领取奖励"
  },
  "og_about3": {
      "en": "Your OG identity has changed recently, so it is now in the freezing period.",
      "ja": "OG ステータスが最近変更されたため、現在保留中です。",
      "ko": "귀하의 OG 신원은 최근 변경되어 현재 동결 기간에 있습니다.",
      "zh": "您的OG身份最近發生了變化，所以現在處於凍結期。",
      "zh_cn": "您的OG身份最近发生了变化，所以现在处于冻结期。"
  },
  "og_cancel_button": {
      "en": "Cancel",
      "ja": "キャンセル",
      "ko": "취소",
      "zh": "取消",
      "zh_cn": "取消"
  },
  "og_claim_reward": {
      "en": "Claim Rewards",
      "ja": "報酬を受け取る",
      "ko": "보상 청구",
      "zh": "領取獎勵",
      "zh_cn": "领取奖励"
  },
  "og_claimed": {
      "en": "Claimed",
      "ja": "受取済",
      "ko": "청구됨",
      "zh": "已領取",
      "zh_cn": "已领取"
  },
  "og_close_button": {
      "en": "Click to close",
      "ja": "クリックして閉じる",
      "ko": "닫으려면 클릭하세요.",
      "zh": "點擊關閉",
      "zh_cn": "点击关闭"
  },
  "og_confirm_button": {
      "en": "Confirm",
      "ja": "確認",
      "ko": "확인하다",
      "zh": "確認",
      "zh_cn": "确认"
  },
  "og_congratulations": {
      "en": "Congratulations",
      "ja": "おめでとう",
      "ko": "축하해요",
      "zh": "恭喜",
      "zh_cn": "恭喜"
  },
  "og_congratulations_toast": {
      "en": "You are a distinguished OG player，so you can log in every day to receive OG exclusive rewards。",
      "ja": "あなたは名高い OG プレイヤーです。毎日ログインして OG 限定の報酬を受け取りましょう。",
      "ko": "당신은 뛰어난 OG 플레이어이므로 매일 로그인하여 OG 독점 보상을 받을 수 있습니다.",
      "zh": "您是尊貴的OG玩家，每天登錄即可領取OG專屬獎勵。",
      "zh_cn": "您是尊贵的OG玩家，每天登录即可领取OG专属奖励。"
  },
  "og_congratulations_toast2": {
      "en": " Note:If your OG status changes during this period，you will not be able to claim the rewards on the day of the reward until you restore your OG status.",
      "ja": "注: この期間中に OG ステータスが変更された場合、OG ステータスを回復するまで、特典当日に報酬を受け取ることはできません。",
      "ko": "참고: 이 기간 동안 OG 상태가 변경되면 OG 상태를 복원할 때까지 보상 당일 보상을 받을 수 없습니다.",
      "zh": "註意：如果您的OG狀態在此期間發生變化，您將無法在獎勵當天領取獎勵，直到您恢復OG狀態為止。",
      "zh_cn": "注意：如果您的OG状态在此期间发生变化，您将无法在奖励当天领取奖励，直到您恢复OG状态为止。"
  },
  "og_cum": {
      "en": "Cumulative sign in",
      "ja": "累積チェックイン数",
      "ko": "누적 로그인",
      "zh": "累計簽到",
      "zh_cn": "累计签到"
  },
  "og_deadline": {
      "en": "Countdown",
      "ja": "カウントダウン",
      "ko": "카운트다운",
      "zh": "倒計時",
      "zh_cn": "倒计时"
  },
  "og_get_method": {
      "en": "How to become an OG player ？>>>",
      "ja": "OGプレイヤーになるにはどうすればいいですか？>>>",
      "ko": "OG 플레이어가 되려면 어떻게 해야 하나요? >>>",
      "zh": "如何成為OG玩家？>>>",
      "zh_cn": "如何成为OG玩家？>>>"
  },
  "og_get_method_title": {
      "en": "How to become an OG player ？",
      "ja": "OGプレイヤーになるにはどうすればいいですか？",
      "ko": "OG 플레이어가 되려면 어떻게 해야 하나요?",
      "zh": "如何成為OG玩家？",
      "zh_cn": "如何成为OG玩家？"
  },
  "og_get_method_toast": {
      "en": "Go to the NFT market to buy an OG-NFT",
      "ja": "NFT マーケットに行って OG-NFT を購入します",
      "ko": "OG-NFT를 구매하려면 NFT 시장으로 이동하세요.",
      "zh": "去NFT市場購買OG-NFT",
      "zh_cn": "去NFT市场购买OG-NFT"
  },
  "og_get_method_toast2": {
      "en": "If you hold an OG-NFT above LV44 and your DC level reaches LV15 or above, please open the ticket and provide the proof.",
      "ja": "LV44以上のOG-NFTを保有し、DCレベルがLV15以上に達している場合は、チケットを開いて証明を提示してください。",
      "ko": "LV44 이상의 OG-NFT를 보유하고 DC 레벨이 LV15 이상에 도달한 경우 티켓을 열고 증거를 제출하세요.",
      "zh": "如果您持有LV44以上的OG-NFT且DC等級達到LV15以上，請開票並提供證明。",
      "zh_cn": "如果您持有LV44以上的OG-NFT且DC等级达到LV15以上，请开票并提供证明。"
  },
  "og_get_method_toast3": {
      "en": "Once the OG NFT move out from wallet or sale, the relevant OG role will be removed.",
      "ja": "OG NFTを販売またはウォレットから移動すると、関連する OGロールが削除されます。",
      "ko": "OG NFT가 지갑이나 판매에서 벗어나면 관련 OG 역할이 제거됩니다.",
      "zh": "一旦 OG NFT 從錢包中移出或出售，相關的 OG 角色將被刪除。",
      "zh_cn": "一旦 OG NFT 从钱包中移出或出售，相关的 OG 角色将被删除。"
  },
  "og_get_method_toast4": {
      "en": "Please note that the relevant game account wallet information provided by applying for this identity must not be duplicated with other DC accounts.",
      "ja": "OG申請に用いるゲーム アカウント ウォレット情報は、他の DC アカウントと重複してはいけないことに注意してください。",
      "ko": "본 ID 신청 시 제공되는 해당 게임 계정 지갑 정보는 다른 DC 계정과 중복되어서는 안 되므로 주의하시기 바랍니다.",
      "zh": "請註意，申請該身份時提供的相關遊戲賬戶錢包信息不得與其他DC賬戶重復。",
      "zh_cn": "请注意，申请该身份时提供的相关游戏账户钱包信息不得与其他DC账户重复。"
  },
  "og_get_method_toast5": {
      "en": "Please put the OG NFT in the wallet of the game account to receive rewards!",
      "ja": "報酬を受け取るには、ゲームアカウントのウォレットにOG NFTを入れてください!",
      "ko": "보상을 받으려면 OG NFT를 게임 계정의 지갑에 넣어주세요!",
      "zh": "請將OG NFT放入遊戲賬戶錢包即可領取獎勵！",
      "zh_cn": "请将OG NFT放入游戏账户钱包即可领取奖励！"
  },
  "og_locked": {
      "en": "Locked",
      "ja": "ロックされています",
      "ko": "잠김",
      "zh": "未解鎖",
      "zh_cn": "未解锁"
  },
  "og_no_reward_tips": {
      "en": "No Rewards currently",
      "ja": "現在報酬はありません",
      "ko": "현재 보상 없음",
      "zh": "當前沒有獎勵",
      "zh_cn": "当前没有奖励"
  },
  "og_no_reward_tips2": {
      "en": "Please wait for the new rewards pool",
      "ja": "新しい報酬プールをお待ちください",
      "ko": "새로운 보상 풀을 기다려주세요",
      "zh": "請等待新的獎勵池",
      "zh_cn": "请等待新的奖励池"
  },
  "og_ok_button": {
      "en": "OK",
      "ja": "OK",
      "ko": "좋아요",
      "zh": "好的",
      "zh_cn": "好的"
  },
  "og_opps": {
      "en": "Opps!...",
      "ja": "おっと！...",
      "ko": "맙소사!...",
      "zh": "哎呀！...",
      "zh_cn": "哎呀！..."
  },
  "og_opps_about": {
      "en": "Insufficient ARG Balance, unable to purchase.",
      "ja": "ARG が不足しているため、購入できません",
      "ko": "ARG 잔액이 부족하여 구매할 수 없습니다.",
      "zh": "ARG余額不足，無法購買。",
      "zh_cn": "ARG余额不足，无法购买。"
  },
  "og_page": {
      "en": "Sign in",
      "ja": "Sign in",
      "ko": "로그인",
      "zh": "Sign in",
      "zh_cn": "Sign in"
  },
  "og_pro_reward": {
      "en": "Pro Reward",
      "ja": "プロの報酬",
      "ko": "프로 보상",
      "zh": "高級獎勵",
      "zh_cn": "高级奖励"
  },
  "og_quit_button": {
      "en": "Quit",
      "ja": "やめる",
      "ko": "그만두다",
      "zh": "退出",
      "zh_cn": "退出"
  },
  "og_title": {
      "en": "Sign-in Reward",
      "ja": "Sign-in Reward",
      "ko": "로그인 보상",
      "zh": "Sign-in Reward",
      "zh_cn": "Sign-in Reward"
  },
  "og_unlock_button": {
      "en": "Unlockable after upgrade",
      "ja": "アップグレード後にロック解除可能",
      "ko": "업그레이드 후 잠금 해제 가능",
      "zh": "升級後可解鎖",
      "zh_cn": "升级后可解锁"
  },
  "og_upgrade_fail_toast": {
      "en": "Upgrade failed",
      "ja": "アップグレードに失敗しました",
      "ko": "업그레이드 실패",
      "zh": "升級失敗",
      "zh_cn": "升级失败"
  },
  "og_upgrade_reward": {
      "en": "Upgrade Reward",
      "ja": "アップグレード報酬",
      "ko": "업그레이드 보상",
      "zh": "升級獎勵",
      "zh_cn": "升级奖励"
  },
  "og_upgrade_success_toast": {
      "en": "Upgrade successfully",
      "ja": "アップグレードが成功しました",
      "ko": "성공적으로 업그레이드",
      "zh": "升級成功",
      "zh_cn": "升级成功"
  },
  "version": 105
}